import { render } from "./DesignMyApp.vue?vue&type=template&id=6d0f1245&scoped=true"
import script from "./DesignMyApp.vue?vue&type=script&lang=js"
export * from "./DesignMyApp.vue?vue&type=script&lang=js"

import "./DesignMyApp.vue?vue&type=style&index=0&id=6d0f1245&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d0f1245"]])

export default __exports__